"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _dealerList = _interopRequireDefault(require("../../styles/dealer-list.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var _types = _interopRequireDefault(require("../types"));
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var hasComma = function hasComma(nextSnippet) {
  return nextSnippet !== '' ? ', ' : '';
};
var getAddressPart = {
  address1: function address1(addressArr) {
    return "" + addressArr[0] + (addressArr[0] !== '' ? hasComma(addressArr[1]) : '') + addressArr[1];
  },
  address2: function address2(add3) {
    return "" + hasComma(add3) + add3;
  },
  cityPart: function cityPart(_cityPart) {
    return "" + hasComma(_cityPart) + _cityPart;
  },
  district: function district(_district) {
    return "" + hasComma(_district) + _district;
  },
  municipality: function municipality(_municipality) {
    return "" + hasComma(_municipality) + _municipality;
  },
  postalCode: function postalCode(_postalCode) {
    return "" + hasComma(_postalCode) + _postalCode;
  }
};
var makeAddress = function makeAddress(address, addressOrder) {
  var order = addressOrder || ['address1', 'address2', 'cityPart', 'district', 'municipality', 'postalCode'];
  var addressData = {
    address1: [handleNestedProp(address, 'address.addressLine1'), handleNestedProp(address, 'address.addressLine2')],
    address2: handleNestedProp(address, 'address.addressLine3'),
    cityPart: handleNestedProp(address, 'address.city'),
    district: handleNestedProp(address, 'address.district'),
    municipality: handleNestedProp(address, 'address.municipality'),
    postalCode: handleNestedProp(address, 'address.postalArea')
  };
  var postalCodeInAddress = addressData.address1[0].includes(addressData.postalCode) || addressData.address1[1].includes(addressData.postalCode);
  if (postalCodeInAddress) {
    order = order.filter(function (key) {
      return key !== 'postalCode';
    });
  }
  return order.map(function (addressPart) {
    return getAddressPart[addressPart](addressData[addressPart]);
  }).join('');
};
var DealerAddress = function DealerAddress(_ref) {
  var address = _ref.address,
    addressOrder = _ref.addressOrder,
    theme = _ref.theme;
  if (!(0, _checkProps["default"])(address)) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _dealerList["default"].dealerAddress + " " + theme.smallType
    }, makeAddress(address, addressOrder));
  }
  return null;
};
var _default = DealerAddress;
exports["default"] = _default;